import { formatOddDisplay } from '@bto-services/utils';

/**
 * Global mixins availbe tryout the app
 */
export const formatedOutcomeMixin = {
  computed: {
    /**
     * Global metohd for outcome formating
     * @returns {converted}
     */
    formatedOutcome() {
      return formatOddDisplay(this.outcome.originalDecimalOutcome, this.$root.oddFormat);
    }
  }
};
